<template>
    <div class="filter__options pb-4 hide">
        <div class="container">
            <div class="row mb-4">
                <div class="col-sm-8 col-md-8 col-lg-10">
                    <search-input-component
                        v-model="search_query"
                        :config="searchConfig"
                        ></search-input-component>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-2">
                    <button class="btn btn-primary filter__options__clear"
                        v-on:click="resetFilter">Clear Filters</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-5 filter__options__radio">
                    <h4>Crop Type</h4>
                    <div class="form-group bmd-form-group clearfix radio-group radio-group--croptype " role="group" aria-label="Basic example">
                        <div class="btn-group filter__options__radio__btns">
                            <template  v-for="option in [
                                { value: 'Field Crops', text: 'Field', icon: '/img/site/icons/field-crop-gr.svg' },
                                { value: 'Covered Crops', text: 'Greenhouse', icon: '/img/site/icons/greenhouse.svg' },
                                { value: 'Covered Crops,Field Crops', text: 'Both', icon: null },
                            ]">
                                <label type="button" :class="['btn', 'btn-secondary', _.includes(cropTypes, option.value) ? 'active' : '']">
                                    <input v-model="cropTypes"
                                        :value="option.value"
                                        :checked="_.includes(cropTypes, option.value)"
                                        type="checkbox"
                                        name="crop_types"
                                        autocomplete="off">
                                    {{ option.text }} <img v-if="option.icon" :src="option.icon" :alt="option.text" width="22">
                                </label>
                            </template>
                        </div>
                    </div>

                    <h4>Seed Type</h4>
                    <div class="form-group bmd-form-group clearfix radio-group radio-group--seedtype" role="group" aria-label="Basic example">
                        <div class="btn-group filter__options__radio__btns">
                            <template  v-for="option in [
                                { value: 'Organic Seed', text: 'Organic', icon: '/img/site/icons/organic-gr.svg' },
                                { value: 'Untreated Seed', text: 'Untreated', icon: '/img/site/icons/untreated-gr.svg' },
                                { value: 'Treated Seed', text: 'Treated', icon: '/img/site/icons/treated.svg' },
                                // { value: 'Primed Pill', text: 'Primed', icon: '/img/site/icons/primed.svg' },
                            ]">
                                <label type="button" :class="['btn', 'btn-secondary', option.text, _.includes(seedTypes, option.value) ? 'active' : '']">
                                    <input v-model="seedTypes"
                                        :value="option.value"
                                        :checked="_.includes(seedTypes, option.value)"
                                        type="checkbox"
                                        name="seed_types"
                                        autocomplete="off">
                                    {{ option.text }} <img v-if="option.icon" :src="option.icon" :alt="option.text" width="22">
                                </label>
                            </template>
                        </div>
                    </div>

                    <!-- <h4>Production Type</h4>
                    <div class="form-group bmd-form-group clearfix radio-group radio-group--productiontype" role="group" aria-label="Basic example">
                        <div class="btn-group filter__options__radio__btns">
                            <template  v-for="option in [
                                { value: 'Potted Production', text: 'Potted Production', icon: '/img/site/icons/potted.svg' },
                                { value: 'Cut & Process', text: 'Cut & Process', icon: '/img/site/icons/cut-and-process.svg' },
                            ]">
                                <label type="button" :class="['btn', 'btn-secondary', option.text, _.includes(productionTypes, option.value) ? 'active' : '']">
                                    <input v-model="productionTypes"
                                        :value="option.value"
                                        :checked="_.includes(productionTypes, option.value)"
                                        type="checkbox"
                                        name="production_types"
                                        autocomplete="off">
                                    {{ option.text }} <img v-if="option.icon" :src="option.icon" :alt="option.text">
                                </label>
                            </template>
                        </div>
                    </div> -->

                    <h4>Harvest Season</h4>
                    <div class="form-group bmd-form-group clearfix radio-group radio-group--harvest" role="group" aria-label="Basic example">
                        <div class="btn-group filter__options__radio__btns">
                            <template  v-for="option in [
                                { value: '1,2,3', text: 'Spring', icon: null },
                                { value: '4,5,6', text: 'Summer', icon: null },
                                { value: '7,8,9', text: 'Autumn', icon: null },
                                { value: '10,11,12', text: 'Winter', icon: null },
                            ]">
                                <label type="button" :class="['btn', 'btn-secondary', _.includes(harvestMonths, option.value) ? 'active' : '']">
                                    <input v-model="harvestMonths"
                                        :value="option.value"
                                        :checked="_.includes(harvestMonths, option.value)"
                                        type="checkbox"
                                        name="harvest_months"
                                        autocomplete="off">
                                    {{ option.text }} <img v-if="option.icon" :src="option.icon" :alt="option.text">
                                </label>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-7">
                    <div class="d-flex align-items-start location-title mb-2">
                        <h4>Location</h4>
                        <p><small>select more than one location if required</small></p>
                    </div>
                    <div class="location">

                        <div v-for="loc in _.values(locationMap)"
                            class="form-check location__check">
                            <label class="location__check__label" :for="loc.id">{{ loc.name }}
                                <input type="checkbox"
                                    :id="loc.id"
                                    :value="loc.id"
                                    v-model="locations"
                                    name=locations
                                    class="location__check__input">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SearchInputComponent from './form/SearchInputComponent';
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        const locations = window.sessionStorage.getItem('filter:locations') || '';

        return {
            search_query: null,
            keywords: [],
            crop_types: window.sessionStorage.getItem('filter:crop_types') || '',
            seed_types: window.sessionStorage.getItem('filter:seed_types') || '',
            production_types: window.sessionStorage.getItem('filter:production_types') || '',
            harvest_months: window.sessionStorage.getItem('filter:harvest_months') || '',
            locations: _.chain(locations).split(',').filter().value(),
            locationMap: {

            },
            files: [],
        }
    },

    created() {
        this._searchApi = _.debounce(this.searchApi, 300);

        _.chain(this.initialData)
            .get('locations', [])
            .map(loc => {
                this.locationMap[loc.id] = loc;
            })
            .value();
    },

    mounted() {
        const query = new URLSearchParams(window.location.search);
        this.search_query = query.get('q');

        if (this.search_query
            || this.crop_types
            || this.seed_types
            || this.production_types
            || this.harvest_months
            || _.get(this.locations, 'length', 0)
        ) {
            $(() => {
                $('#filterToggler').click();
            })
        }

        this.updateFilter();
    },

    props: ['initialData'],

    components: {
        SearchInputComponent,
    },

    mixins: [UtilsMixin],

    watch: {
        search_query: {
            handler(newVal) {
                window.history.pushState(null, null, '?q=' + (newVal || ''));
                this.$nextTick(() => this.updateFilter());
            },
        },
        crop_types: {
            handler(newVal) {
                // window.sessionStorage.setItem('filter:crop_types', newVal || '');
                this.$nextTick(() => this.updateFilter());
            },
            deep: true,
        },
        seed_types: {
            handler(newVal) {
                // window.sessionStorage.setItem('filter:seed_types', newVal || '');
                this.$nextTick(() => this.updateFilter());
            },
            deep: true,
        },
        production_types: {
            handler(newVal) {
                // window.sessionStorage.setItem('filter:seed_types', newVal || '');
                this.$nextTick(() => this.updateFilter());
            },
            deep: true,
        },
        harvest_months: {
            handler(newVal) {
                // window.sessionStorage.setItem('filter:harvest_months', newVal || '');
                this.$nextTick(() => this.updateFilter());
            },
            deep: true,
        },
        locations: {
            handler(newVal) {
                // window.sessionStorage.setItem('filter:locations', _.chain(newVal).filter().join(',').value());
                this.$nextTick(() => this.updateFilter());
            },
            deep: true,
        },
    },

    computed: {
        category() {
            return _.get(this.initialData, 'category.id', null);
        },
        cropTypes: {
            set(val) {
                this.crop_types = _.chain(val)
                    .filter()
                    .last()
                    .value();
            },
            get() {
                return _.chain(this.crop_types)
                    .split(';')
                    .filter()
                    .value();
            },
        },
        seedTypes: {
            set(val) {
                this.seed_types = _.chain(val)
                    .filter()
                    .last()
                    .value();
            },
            get() {
                return _.chain(this.seed_types)
                    .split(';')
                    .filter()
                    .value();
            },
        },
        productionTypes: {
            set(val) {
                this.production_types = _.chain(val)
                    .filter()
                    .last()
                    .value();
            },
            get() {
                return _.chain(this.production_types)
                    .split(';')
                    .filter()
                    .value();
            },
        },
        harvestMonths: {
            set(val) {
                this.harvest_months = _.chain(val)
                    .filter()
                    .last()
                    .value();
            },
            get() {
                return _.chain(this.harvest_months)
                    .split(';')
                    .filter()
                    .value();
            },
        },
        searchConfig() {
            return {
                api: this.api,
                keywords: this.keywords,
                rootPath: window.location.pathname,
                submitOnChange: false,
            }
        },
    },

    methods: {
        updateFilter() {
            const query = _.chain([
                'category', 'crop_types', 'seed_types', 'production_types', 'harvest_months', 'locations', 'search_query'
            ]).map(field => {
                const value = _.isArray(this[field]) ? this[field].join(',') : this[field];

                return [field, value];
            })
            .filter(entry => entry[1])
            .fromPairs()
            .value();

            // if (_.isEmpty(query)) return;

            this._searchApi(query);
        },

        searchApi(query) {
            window.dispatchEvent(new CustomEvent('vue:product-list-loading'));
            return this.api.getData('/../search', query)
                .then((res) => {
                    this.keywords = _.get(res, 'keywords', []);
                    this.updateProduct(res);
                })
        },

        createDate(date) {
            return M(date, 'YYYY-MM-DD hh:mm:ss');
        },

        resetFilter() {
            this.search_query = '';
            this.crop_types = '';
            this.seed_types = '';
            this.production_types = '';
            this.harvest_months = '';
            this.locations = [];
            this.updateProduct({
                categories: null,
                products: null,
            });
        },

        updateProduct(data) {
            const event = new CustomEvent('vue:product-list', {
                detail: data
            });
            console.log(data);
            window.dispatchEvent(event);
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/ProductListFilterComponent.vue